import { render } from "./uploadModal.vue?vue&type=template&id=bd5f1c14&scoped=true"
import script from "./uploadModal.vue?vue&type=script&lang=js"
export * from "./uploadModal.vue?vue&type=script&lang=js"

import "./uploadModal.vue?vue&type=style&index=0&id=bd5f1c14&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5f1c14"]])

export default __exports__